window.addEventListener("load",function(){
     $(".contact-tab-item").click(function(){
      if(!$(this).hasClass("active")){
        let index = $(this).index()
        $(this).siblings().removeClass("active")
        $(this).addClass("active")
        $(this).parent().parent().find(".contact-tab-contents").find(".contact-tab-content").removeClass("active")
        $(this).parent().parent().find(".contact-tab-contents").find(".contact-tab-content").eq(index).addClass("active")
      }
    })
      $(".js-open-giveaway-pop").click(function(){
      $(".giveaway-pop").fadeIn()
           $("body").addClass("popshow")
      $("html").addClass("popshow")
    })
    $(".giveaway-pop").click(function() {
        $(".giveaway-pop").fadeOut()
        $("body").removeClass("popshow")
        $("html").removeClass("popshow")
    })
    $(".giveaway-pop-box").click(function(e) {
        e.stopPropagation()
    })
    $(".close-giveaway-pop").click(function() {
         $(".giveaway-pop").fadeOut()
         $("body").removeClass("popshow")
         $("html").removeClass("popshow")
    })
    $(".js_show_custom").click(function() {
      let id = $(this).data("htmlid")
      $(id).find(".custom_html_content").removeClass("d-none")
    })
})